import { render, staticRenderFns } from "./view.vue?vue&type=template&id=77334d52&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77334d52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77334d52')) {
      api.createRecord('77334d52', component.options)
    } else {
      api.reload('77334d52', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=77334d52&scoped=true", function () {
      api.rerender('77334d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/verify/logic/view.vue"
export default component.exports